var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "GenderRadioButtonArea", class: { isPc: !_vm.isSp } },
      [
        _c(
          "InputLabel",
          {
            staticClass: "labelArea",
            class: {
              isPc: !_vm.isSp,
              isHasLabel: !_vm.isSp && (_vm.required || _vm.optional),
            },
            attrs: { required: _vm.required },
          },
          [_vm._v("\n      性別\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "GenderRadioButtonArea__form" },
          [
            _c("RadioButton", {
              staticClass: "inputItem",
              class: { hasError: _vm.hasError, isPc: !_vm.isSp },
              attrs: {
                "item-list": _vm.itemListTop,
                disabled: _vm.disabled,
                "flex-auto-num": 2,
                "question-id": "gender",
              },
              on: { change: _vm.onChange },
              model: {
                value: _vm.handleSelectValue,
                callback: function ($$v) {
                  _vm.handleSelectValue = $$v
                },
                expression: "handleSelectValue",
              },
            }),
            _vm._v(" "),
            _c("RadioButton", {
              staticClass: "inputItem inputItem--mt8",
              class: { hasError: _vm.hasError, isPc: !_vm.isSp },
              attrs: {
                "item-list": _vm.itemListBottom,
                disabled: _vm.disabled,
                "question-id": "gender",
              },
              on: { change: _vm.onChange },
              model: {
                value: _vm.handleSelectValue,
                callback: function ($$v) {
                  _vm.handleSelectValue = $$v
                },
                expression: "handleSelectValue",
              },
            }),
            _vm._v(" "),
            _c("InputItem", {
              staticClass: "inputItem inputItem__textForm",
              class: { hasInputError: _vm.hasInputError, isPc: !_vm.isSp },
              attrs: {
                "input-type": "text",
                disabled: _vm.isTextAreaDisabled,
                maxlength: "40",
              },
              on: {
                change: _vm.inputValue,
                blur: _vm.onBlur,
                focus: _vm.onFocusGender,
              },
              model: {
                value: _vm.handleInputValue,
                callback: function ($$v) {
                  _vm.handleInputValue = $$v
                },
                expression: "handleInputValue",
              },
            }),
            _vm._v(" "),
            _c("p", { staticClass: "GenderRadioButtonArea__form__message" }, [
              _vm._v("最大40文字まで"),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "underInputArea", class: { isPc: !_vm.isSp } },
      [
        _c("PartialErrorMessage", {
          staticClass: "partialErrorComponent",
          attrs: { "is-sp-flg": true, error: _vm.errorFromOuterExpression },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      { staticClass: "underInputAreaMessage", class: { isPc: !_vm.isSp } },
      [
        _vm._v(
          "\n    自由記載の内容は、プロフィール画面で閲覧可能です。保護者や学校関係者への公開はありません。\n  "
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "underInputArea", class: { isPc: !_vm.isSp } },
      [
        _c("PartialErrorMessage", {
          staticClass: "partialErrorComponent",
          attrs: { "is-sp-flg": true, error: _vm.errorFromOuter },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }